import { Component } from '@angular/core';
import { IDHeaderIneraAdminComponent } from '@inera/ids-angular/components/header-inera-admin';
import { IDFooterIneraAdminComponent } from '@inera/ids-angular/components/footer-inera-admin';
import { IDLinkModule } from '@inera/ids-angular/components/link';
import { IDCardModule } from '@inera/ids-angular/components/card';

@Component({
  selector: 'idp-loggedout',
  templateUrl: './loggedout.component.html',
  styleUrls: ['./loggedout.component.scss'],
  imports: [IDHeaderIneraAdminComponent, IDFooterIneraAdminComponent, IDLinkModule, IDCardModule]
})
export class LoggedoutComponent {}
